import { connect } from 'react-redux'
import { openTrainSelectModal } from '../actions'
import NearbyTrainPositionsApp from '../components/train_positions/NearbyTrainPositionsApp'
import { createCommonActionCreators } from './helpers/trainActionCreators'
import { processTrains } from './helpers/trainUtils'

const mapStateToProps = state => {
  const { updatedAt, jrLocationUpdatedAt } = state.trainPositionReducer
  const { themeName } = state.themeReducer
  const { popinfoId } = state.userSettingsReducer
  const trains = processTrains(state.trainPositionReducer.trains)

  return {
    trains,
    updatedAt,
    jrLocationUpdatedAt,
    themeName,
    popinfoId,
  }
}

const mapDispatchToProps = (dispatch) => {
  const commonActions = createCommonActionCreators(dispatch)

  return {
    ...commonActions,
    openTrainSelectModal: (selectingTrains) => {
      dispatch(openTrainSelectModal(selectingTrains))
    }
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(NearbyTrainPositionsApp)
